// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px,
    rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
  border: 1px solid #cdced563;
  font-size: 12px !important;
}
.header_contaier {
  width: 90%;
  margin: 0 auto;
  padding: 10px 0;
}

.vas_title {
  color: #27292f;
  font-weight: 700;
  font-size: 18px;
}
a {
  color: #27292f;
  text-decoration: none;
  font-weight: 700;
  font-size: 15px;
}
.home_icon {
  width: 20px;
  height: 20px;
}
.arn_no_text {
  font-size: 14px;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
.arn_no_text span {
  font-weight: 700;
  padding: 0;
}
.border_bottom {
  background: #cdced563;
  height: 1px;
  width: 100%;
}
.user_name {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: 2px solid black;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background: #27292f;
  color: white;
  cursor: pointer;
  font-weight: 600;
}
.user_name:hover {
  background-color: white;
  color: #27292f;
}
.scroll_link {
  font-weight: 600;
  font-size: 13px;
  font-family: sans-serif;
  color: #1a1b1f !important;
  cursor: pointer;
}
.scroll_link span {
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
}

.scroll_link:hover {
  color: #1f77b4 !important;
}
.scroll_link:hover span {
  color: #1f77b4;
}

.bottom_header {
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  background-color: rgba(249, 249, 249, 0.384);
  width: 100%;
}
.menu_section {
  position: absolute;
  top: 40px;
  width: 250px;
  background: white;
  right: -100px;
  height: auto;
  z-index: 101;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.212);
}

.intials {
  background: black;
  color: white;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 1px solid black;
  font-weight: 500;
  transition: transform 0.3s ease-in-out;
}

.intials:hover {
  transform: scale(1.1);
  background: transparent;
  color: black;
}

.menu_section h6 {
  font-size: 15px;
  font-weight: 600;
}
.menu_section button {
  width: 100%;
  background: black;
  border: 1px solid black;
  padding: 5px 20px;
  color: white;
  border-radius: 5px;
}
.menu_section button:hover {
  background: white;
  color: black;
}
.activeLink {
  color: #1f77b4 !important;
}
.home_img {
  width: 20px;
  height: 20px;
}
.link_wrapper {
  display: flex;
  align-items: center;
  gap: 20px;
}
@media screen and (max-width: 900px) {
  .logo_second {
    display: none;
  }
  .menu_section {
    right: -10%;
  }
}

.menuIcon {
  display: none;
}
.menuIcon img {
  width: 20px;
  height: 20px;
}

.mobile_link_section {
  height: 100%;
  display: flex;
  flex-direction: column;
  color: black;
  width: 90%;
  margin: 0 auto;
  padding: 20px 10px;
  gap: 15px;
}

.user_details {
  display: none;
}

.mobile_menu {
  position: absolute;
  top: 35px;
  width: 200px;
  background: white;
  right: -10%;
  height: auto;
  z-index: 101;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.212);
}
@media screen and (max-width: 700px) {
  .bottom_header,
  .link_wrapper {
    display: none;
  }
  .menuIcon {
    display: block !important;
    cursor: pointer;
  }
  .user_details {
    display: block !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/index.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ;wCACsC;EACtC,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kCAA0B;UAA1B,0BAA0B;EAC1B,4CAA4C;EAC5C,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ;;uEAEqE;EACrE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ;;uEAEqE;EACrE,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE;;IAEE,aAAa;EACf;EACA;IACE,yBAAyB;IACzB,eAAe;EACjB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".header_wrapper {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  z-index: 100;\r\n  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px,\r\n    rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;\r\n  border: 1px solid #cdced563;\r\n  font-size: 12px !important;\r\n}\r\n.header_contaier {\r\n  width: 90%;\r\n  margin: 0 auto;\r\n  padding: 10px 0;\r\n}\r\n\r\n.vas_title {\r\n  color: #27292f;\r\n  font-weight: 700;\r\n  font-size: 18px;\r\n}\r\na {\r\n  color: #27292f;\r\n  text-decoration: none;\r\n  font-weight: 700;\r\n  font-size: 15px;\r\n}\r\n.home_icon {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n.arn_no_text {\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n}\r\n.arn_no_text span {\r\n  font-weight: 700;\r\n  padding: 0;\r\n}\r\n.border_bottom {\r\n  background: #cdced563;\r\n  height: 1px;\r\n  width: 100%;\r\n}\r\n.user_name {\r\n  width: 35px;\r\n  height: 35px;\r\n  border-radius: 50%;\r\n  border: 2px solid black;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 10px;\r\n  background: #27292f;\r\n  color: white;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n}\r\n.user_name:hover {\r\n  background-color: white;\r\n  color: #27292f;\r\n}\r\n.scroll_link {\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n  font-family: sans-serif;\r\n  color: #1a1b1f !important;\r\n  cursor: pointer;\r\n}\r\n.scroll_link span {\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n}\r\n\r\n.scroll_link:hover {\r\n  color: #1f77b4 !important;\r\n}\r\n.scroll_link:hover span {\r\n  color: #1f77b4;\r\n}\r\n\r\n.bottom_header {\r\n  backdrop-filter: blur(4px);\r\n  background-color: rgba(249, 249, 249, 0.384);\r\n  width: 100%;\r\n}\r\n.menu_section {\r\n  position: absolute;\r\n  top: 40px;\r\n  width: 250px;\r\n  background: white;\r\n  right: -100px;\r\n  height: auto;\r\n  z-index: 101;\r\n  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,\r\n    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,\r\n    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;\r\n  border-radius: 5px;\r\n  border: 1px solid rgba(0, 0, 0, 0.212);\r\n}\r\n\r\n.intials {\r\n  background: black;\r\n  color: white;\r\n  border-radius: 50%;\r\n  width: 30px;\r\n  height: 30px;\r\n  text-align: center;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  border: 1px solid black;\r\n  font-weight: 500;\r\n  transition: transform 0.3s ease-in-out;\r\n}\r\n\r\n.intials:hover {\r\n  transform: scale(1.1);\r\n  background: transparent;\r\n  color: black;\r\n}\r\n\r\n.menu_section h6 {\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n}\r\n.menu_section button {\r\n  width: 100%;\r\n  background: black;\r\n  border: 1px solid black;\r\n  padding: 5px 20px;\r\n  color: white;\r\n  border-radius: 5px;\r\n}\r\n.menu_section button:hover {\r\n  background: white;\r\n  color: black;\r\n}\r\n.activeLink {\r\n  color: #1f77b4 !important;\r\n}\r\n.home_img {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n.link_wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px;\r\n}\r\n@media screen and (max-width: 900px) {\r\n  .logo_second {\r\n    display: none;\r\n  }\r\n  .menu_section {\r\n    right: -10%;\r\n  }\r\n}\r\n\r\n.menuIcon {\r\n  display: none;\r\n}\r\n.menuIcon img {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.mobile_link_section {\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  color: black;\r\n  width: 90%;\r\n  margin: 0 auto;\r\n  padding: 20px 10px;\r\n  gap: 15px;\r\n}\r\n\r\n.user_details {\r\n  display: none;\r\n}\r\n\r\n.mobile_menu {\r\n  position: absolute;\r\n  top: 35px;\r\n  width: 200px;\r\n  background: white;\r\n  right: -10%;\r\n  height: auto;\r\n  z-index: 101;\r\n  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,\r\n    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,\r\n    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;\r\n  border-radius: 5px;\r\n  border: 1px solid rgba(0, 0, 0, 0.212);\r\n}\r\n@media screen and (max-width: 700px) {\r\n  .bottom_header,\r\n  .link_wrapper {\r\n    display: none;\r\n  }\r\n  .menuIcon {\r\n    display: block !important;\r\n    cursor: pointer;\r\n  }\r\n  .user_details {\r\n    display: block !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
